import { withRouter } from 'react-router';
import CreateProvisional from './CreateProvisional';

export default withRouter(CreateProvisional);
